import image1 from "../../../../../images/bakery/prueba1.jpg";
import image2 from "../../../../../images/bakery/prueba2.jpg";

export const cardInfo = [
    {   
        id: 1,
        img: image1,
        title: "Lorem ipsum",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis explicabo eaque fugit, saepe quis animi accusantium!"
    },
    {   
        id: 2,
        img: image2,
        title: "Lorem ipsum",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis explicabo eaque fugit, saepe quis animi accusantium!"
    },
    {
        id: 3,
        img: image1,
        title: "Lorem ipsum",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis explicabo eaque fugit, saepe quis animi accusantium!"
    },
    {   
        id: 4,
        img: image2,
        title: "Lorem ipsum",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis explicabo eaque fugit, saepe quis animi accusantium!"
    },
    {
        id: 5,
        img: image1,
        title: "Lorem ipsum",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis explicabo eaque fugit, saepe quis animi accusantium!"
    },
    {   
        id: 6,
        img: image2,
        title: "Lorem ipsum",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis explicabo eaque fugit, saepe quis animi accusantium!"
    },
]